module.exports = __webpack_public_path__ + "img/logo_row_white_jp.b5e9e5ae.svg";